<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">Création d'un Utilisateur</span>
    </sticky>
    <spinner-round :isLoading="loading"></spinner-round>
    <div class="columns is-gapless is-margin-left-on-btn-actions is-margin-right-on-btn-actions is-padding-top">
      <div class="column is-12 is-9-widescreen is-8-fullhd">
        <div class="has-bg-white is-border">
          <user-form v-if="profiles && profiles.length > 0" @submit="submit" :profiles="profiles" :loading="loading"></user-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import UserForm from '@/components/users/UserForm'
  import { Error } from '@/mixins'

  export default {
    name: 'UserCreate',
    mixins: [Error],
    data () {
      return {
        loading: false,
        profiles: []
      }
    },
    components: {
      UserForm
    },
    methods: {
      loadProfils () {
        this.$api.profilService.get().then(r => {
          this.profiles = r.data
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Impossible de récupérer la liste des profils.'
          })
        })
      },
      submit (user, redirect, invitUser = false) {
        this.loading = true
        this.$api.userService.post(user).then(res => {
          this.loading = false
          this.$notify({
            type: 'is-success',
            text: 'L\'utilisateur a bien été créé'
          })
          if (invitUser === true) {
            this.inviteUser(res.data.email)
          }
          this.$router.push({name: 'UserVue', params: {id: res.data.pk}})
        }).catch((err) => {
          this.loading = false
          this.handleError(err, 'Erreur lors de la création de l\'utilisateur.')
        })
      },
      inviteUser (email) {
        this.$api.userService.invite({email: email}, this.$configs.APPHOST).then(() => {
          this.$notify({
            type: 'is-success',
            text: `Un mail d'activation à été envoyé à l'adresse ${email}`
          })
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: `Erreur lors de l'envoi d'un mail d'activation à l'adresse ${email}`
          })
        })
      }
    },
    created () {
      this.loadProfils()
    }
  }
</script>






// WEBPACK FOOTER //
// src/components/users/UserCreate.vue